var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntelligentDashboards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4293",
    "data-name": "Group 4293",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 54.238 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4281",
    "data-name": "Group 4281",
    transform: "translate(0 7.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5142",
    "data-name": "Path 5142",
    d: "M24.078,22.045H.845A.847.847,0,0,1,0,21.2V15.793A4.417,4.417,0,0,1,4.393,11.4H26.95a.847.847,0,0,1,.845.845.909.909,0,0,1-.845.845H4.309A2.632,2.632,0,0,0,1.69,15.709v4.562H24.078a.847.847,0,0,1,.845.845.921.921,0,0,1-.845.929Z",
    transform: "translate(0 -11.4)",
    fill: "#ff0185"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4282",
    "data-name": "Group 4282",
    transform: "translate(0 15.967)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5143",
    "data-name": "Path 5143",
    d: "M4.309,54.933a4.016,4.016,0,0,1-3.041-1.267A4.338,4.338,0,0,1,0,50.54V22.745A.847.847,0,0,1,.845,21.9H24.078a.847.847,0,0,1,.845.845.909.909,0,0,1-.845.845H1.69V50.455a2.6,2.6,0,0,0,2.619,2.619H43.931a2.632,2.632,0,0,0,2.619-2.619v-16.9a.847.847,0,0,1,.845-.845.909.909,0,0,1,.845.845v16.9a4.417,4.417,0,0,1-4.393,4.393H4.309Z",
    transform: "translate(0 -21.9)",
    fill: "#ff0185"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4283",
    "data-name": "Group 4283",
    transform: "translate(4.9 11.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5144",
    "data-name": "Path 5144",
    d: "M8.5,18.39H6.645a.847.847,0,0,1-.845-.845.909.909,0,0,1,.845-.845H8.5a.845.845,0,0,1,0,1.69Z",
    transform: "translate(-5.8 -16.7)",
    fill: "#f48116"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4284",
    "data-name": "Group 4284",
    transform: "translate(9.04 11.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5145",
    "data-name": "Path 5145",
    d: "M13.4,18.39H11.545a.847.847,0,0,1-.845-.845.909.909,0,0,1,.845-.845H13.4a.845.845,0,0,1,0,1.69Z",
    transform: "translate(-10.7 -16.7)",
    fill: "#f48116"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4285",
    "data-name": "Group 4285",
    transform: "translate(13.179 11.574)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5146",
    "data-name": "Path 5146",
    d: "M18.3,18.39H16.445a.847.847,0,0,1-.845-.845.909.909,0,0,1,.845-.845H18.3a.845.845,0,0,1,0,1.69Z",
    transform: "translate(-15.6 -16.7)",
    fill: "#f48116"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4286",
    "data-name": "Group 4286",
    transform: "translate(5.829 20.445)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5147",
    "data-name": "Path 5147",
    d: "M21.853,39.788H9.519A2.632,2.632,0,0,1,6.9,37.169v-7.35A2.632,2.632,0,0,1,9.519,27.2H21.853a2.632,2.632,0,0,1,2.619,2.619v7.35A2.632,2.632,0,0,1,21.853,39.788Zm0-10.9H9.519a.847.847,0,0,0-.845.845v7.434a.847.847,0,0,0,.845.845H21.853a.847.847,0,0,0,.845-.845v-7.35A.925.925,0,0,0,21.853,28.89Z",
    transform: "translate(-6.9 -27.2)",
    fill: "#96006b"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4287",
    "data-name": "Group 4287",
    transform: "translate(27.879 26.105)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5148",
    "data-name": "Path 5148",
    d: "M34.774,35.59h-.929A.847.847,0,0,1,33,34.745a.909.909,0,0,1,.845-.845h.929a.847.847,0,0,1,.845.845A.909.909,0,0,1,34.774,35.59Z",
    transform: "translate(-33 -33.9)",
    fill: "#f48116"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4288",
    "data-name": "Group 4288",
    transform: "translate(27.879 31.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5149",
    "data-name": "Path 5149",
    d: "M47.193,42.19H33.845A.847.847,0,0,1,33,41.345a.909.909,0,0,1,.845-.845H47.193a.847.847,0,0,1,.845.845A.909.909,0,0,1,47.193,42.19Z",
    transform: "translate(-33 -40.5)",
    fill: "#f48116"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4289",
    "data-name": "Group 4289",
    transform: "translate(5.407 37.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5150",
    "data-name": "Path 5150",
    d: "M43.066,48.79H7.245a.847.847,0,0,1-.845-.845.909.909,0,0,1,.845-.845H43.066a.847.847,0,0,1,.845.845A.909.909,0,0,1,43.066,48.79Z",
    transform: "translate(-6.4 -47.1)",
    fill: "#f48116"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4290",
    "data-name": "Group 4290",
    transform: "translate(5.407 42.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5151",
    "data-name": "Path 5151",
    d: "M43.066,55.39H7.245a.847.847,0,0,1-.845-.845.909.909,0,0,1,.845-.845H43.066a.847.847,0,0,1,.845.845A.909.909,0,0,1,43.066,55.39Z",
    transform: "translate(-6.4 -53.7)",
    fill: "#f48116"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4291",
    "data-name": "Group 4291",
    transform: "translate(26.19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5152",
    "data-name": "Path 5152",
    d: "M45.7,31.133H44.348a2.266,2.266,0,0,1-2.2-1.859l-.338-2.112c0-.169-.169-.253-.253-.338-.338-.084-.591-.253-.929-.338a.384.384,0,0,0-.422,0l-1.69,1.267a2.3,2.3,0,0,1-2.872-.253l-1.014-1.014a2.291,2.291,0,0,1-.253-2.872l1.267-1.69a.377.377,0,0,0,0-.422,9.911,9.911,0,0,1-.422-.929c-.084-.169-.169-.253-.338-.253l-2.028-.338A2.188,2.188,0,0,1,31,17.784V16.348a2.188,2.188,0,0,1,1.859-2.2l2.028-.338c.169,0,.253-.169.338-.253a4.528,4.528,0,0,1,.422-.929.377.377,0,0,0,0-.422l-1.267-1.69a2.3,2.3,0,0,1,.169-2.872l1.014-1.014a2.188,2.188,0,0,1,2.872-.169L40.04,7.731a.279.279,0,0,0,.422,0c.338-.169.591-.253.929-.422a.66.66,0,0,0,.338-.338l.338-2.112A2.434,2.434,0,0,1,44.348,3H45.7a2.266,2.266,0,0,1,2.2,1.859l.338,2.112c0,.169.169.253.253.338.338.084.591.253.929.338a.384.384,0,0,0,.422,0l1.69-1.267a2.2,2.2,0,0,1,2.872.253l1.014,1.014a2.291,2.291,0,0,1,.253,2.872L54.4,12.209a.377.377,0,0,0,0,.422,9.91,9.91,0,0,1,.422.929c.084.169.169.253.338.253l2.028.338a2.188,2.188,0,0,1,1.859,2.2v1.436a2.188,2.188,0,0,1-1.859,2.2l-2.028.338c-.169,0-.253.169-.338.253-.084.338-.253.591-.338.929a.539.539,0,0,0,0,.507l1.267,1.69a2.418,2.418,0,0,1-.169,2.872l-1.267.929a2.188,2.188,0,0,1-2.872.169L49.84,26.4a.279.279,0,0,0-.422,0c-.338.169-.591.253-.929.422-.169.084-.253.169-.253.338L47.9,29.274a2.266,2.266,0,0,1-2.2,1.859Zm-5.322-6.505a1.7,1.7,0,0,1,.929.253c.253.084.507.253.76.338a2.251,2.251,0,0,1,1.436,1.69l.338,2.112a.453.453,0,0,0,.422.422h1.352a.387.387,0,0,0,.422-.338l.338-2.112a2.1,2.1,0,0,1,1.436-1.69,3,3,0,0,0,.76-.338,2.247,2.247,0,0,1,2.281.253l1.69,1.267a.408.408,0,0,0,.591-.084l1.014-1.014a.408.408,0,0,0,0-.591l-1.267-1.69a2.1,2.1,0,0,1-.253-2.2c.084-.253.253-.507.338-.76a2.1,2.1,0,0,1,1.69-1.436l2.028-.338c.253,0,.338-.253.338-.422V16.517a.387.387,0,0,0-.338-.422l-2.028-.338a2.1,2.1,0,0,1-1.69-1.436,3,3,0,0,0-.338-.76,2.424,2.424,0,0,1,.169-2.281l1.267-1.69c.169-.169.084-.422,0-.591L53.05,7.984a.64.64,0,0,0-.338-.169.31.31,0,0,0-.253.084L50.853,9.167a2.206,2.206,0,0,1-2.281.253c-.253-.084-.507-.253-.76-.338a2.251,2.251,0,0,1-1.436-1.69l-.338-2.112a.453.453,0,0,0-.422-.422H44.264a.387.387,0,0,0-.422.338l-.253,2.028a2.1,2.1,0,0,1-1.436,1.69,3,3,0,0,0-.76.338A2.247,2.247,0,0,1,39.11,9l-1.69-1.267c-.253-.253-.422-.084-.591.084L35.816,8.829a.408.408,0,0,0,0,.591l1.267,1.69a2.275,2.275,0,0,1,.169,2.2c-.084.253-.253.507-.338.76a2.1,2.1,0,0,1-1.69,1.436l-2.028.338c-.253,0-.338.253-.338.422V17.7a.387.387,0,0,0,.338.422l2.028.338a2.1,2.1,0,0,1,1.69,1.436,3,3,0,0,0,.338.76A2.227,2.227,0,0,1,37,22.938l-1.267,1.69c-.169.169-.084.422,0,.591l1.014,1.014a.408.408,0,0,0,.591.084l1.69-1.267a2.8,2.8,0,0,1,1.352-.422Z",
    transform: "translate(-31 -3)",
    fill: "#ff0185"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4292",
    "data-name": "Group 4292",
    transform: "translate(34.553 8.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5153",
    "data-name": "Path 5153",
    d: "M46.56,24.221a5.66,5.66,0,1,1,5.66-5.66A5.661,5.661,0,0,1,46.56,24.221Zm0-9.547a3.886,3.886,0,0,0,0,7.772,3.886,3.886,0,0,0,0-7.772Z",
    transform: "translate(-40.9 -12.9)",
    fill: "#96006b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntelligentDashboards);
export default __webpack_public_path__ + "static/media/IntelligentDashboards.9840ff6b624d471872f5af9513a2e6b6.svg";
export { ForwardRef as ReactComponent };